import { defineStore } from 'pinia'

type ErrorMessage = string | string[]
type ErrorMessageCollection =
  | Array<string | Record<string, ErrorMessage>>
  | Record<string, ErrorMessage>

export const useErrorStore = defineStore('error', {
  state: () => ({
    display: false,
    message: [] as ErrorMessageCollection,
    messageWarning: null as unknown as any,
  }),
  actions: {
    clear() {
      this.display = false
      this.message = []
    },
    setError(display: boolean, message?: ErrorMessageCollection) {
      this.display = display
      this.message = message ?? []
    },
    setWarning(display: boolean, message?: any) {
      this.display = display
      return (this.messageWarning = message)
    },
    clearWarning() {
      this.display = false
      this.messageWarning = null
    },
  },
  getters: {
    getMessage(): string[] {
      const values = Array.isArray(this.message) ? this.message : Object.values(this.message)

      return values.flatMap((value) => {
        if (typeof value === 'string') {
          return [value]
        }

        if (Array.isArray(value)) {
          return value
        }

        return Object.values(value).flatMap((nestedValue) =>
          Array.isArray(nestedValue) ? nestedValue : [nestedValue],
        )
      })
    },
  },
})
